<template>
    <div class="menuitem-main">
        <div @click="chooseMenu()" class="menuitem-wrapper">
            <div class="menuitem-img-wrapper">
                <img :src="menuImage" class="img-campaign" />
            </div>
            <div class="menuitem-info" :class="{'active' : isActive}">
                <div class="menuitem-name">{{ campaign.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MenuApi from "@/module/Menu/service/missionbadge.js";
export default {
    name: "ChangePlanItem",
    props: {
        index: Number,
        campaign: Object,
        isActive: Boolean
    },
    data() {
        return {
            activeMenu: '',
            menuImage: null,
        };
    },
    created: function() {
        this.getImage();
    },
    methods: {
        getImage() {
            MenuApi.GetBlob(this.campaign.id).then(response => {
                this.menuImage = response.config.url;
            })
            .catch ((err) => {
                console.log('error ::::    ',err)
            });
        },
        chooseMenu() {
            this.$emit("onChoose", this.index);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/menu/style/menuItem.scss";
.menuitem-main {
    .menuitem-wrapper {
        .menuitem-info{
            background-color: rgba(255, 255, 255, 0.2);
            min-height: 0;

            &.active {
                background-color: #a7907b;
            }
            .menuitem-name{
                padding-bottom: 6px;
            }
        }

    }
}
</style>
